import styled from 'styled-components';
import { Text } from '@naf/text';
import { breakpoints, spacing } from '@naf/theme';

export const LinkList = styled.ul`
  list-style-type: none;
  padding: 0;
  margin: 0;

  @media (max-width: ${breakpoints.m}) {
    margin: 0;
  }
`;

export const StyledHeader = styled(Text)`
  margin: ${spacing.space20} 0 ${spacing.space24};

  @media (max-width: ${breakpoints.l}) {
    margin-top: ${spacing.space32};
  }
`;
